 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK_V2891 from '@/components/eBook_V2891'
 import EBOOK_V28911 from '@/components/eBook_V28911'
 import EBOOK_V28912 from '@/components/eBook_V28912'
 import EBOOK_V28913 from '@/components/eBook_V28913'
 import EBOOK_V28914 from '@/components/eBook_V28914'
 import EBOOK_V28915 from '@/components/eBook_V28915'
 import EBOOK_V28916 from '@/components/eBook_V28916'
 import EBOOK_V28917 from '@/components/eBook_V28917'
 import EBOOK_V28918 from '@/components/eBook_V28918'
 import EBOOK_V28919 from '@/components/eBook_V28919'
 import EBOOK_V289110 from '@/components/eBook_V289110'
 import EBOOK_V289111 from '@/components/eBook_V289111'
 import EBOOK_V289112 from '@/components/eBook_V289112'
 import EBOOK_V289113 from '@/components/eBook_V289113'
 import EBOOK_V289114 from '@/components/eBook_V289114'
 import EBOOK_V289115 from '@/components/eBook_V289115'
 import EBOOK_V289116 from '@/components/eBook_V289116'
 import LOVE_2 from '@/components/love_2'
 import EBOOK_V289117 from '@/components/eBook_V289117'
 import EBOOK_V289118 from '@/components/eBook_V289118'
 import EBOOK_V289119 from '@/components/eBook_V289119'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook_V2891",
 			"name" : "eBook_V2891",
 			"component" : EBOOK_V2891
 		},
 		{
 			"path" : "/eBook_V28911",
 			"name" : "eBook_V28911",
 			"component" : EBOOK_V28911
 		},
 		{
 			"path" : "/eBook_V28912",
 			"name" : "eBook_V28912",
 			"component" : EBOOK_V28912
 		},
 		{
 			"path" : "/eBook_V28913",
 			"name" : "eBook_V28913",
 			"component" : EBOOK_V28913
 		},
 		{
 			"path" : "/eBook_V28914",
 			"name" : "eBook_V28914",
 			"component" : EBOOK_V28914
 		},
 		{
 			"path" : "/eBook_V28915",
 			"name" : "eBook_V28915",
 			"component" : EBOOK_V28915
 		},
 		{
 			"path" : "/eBook_V28916",
 			"name" : "eBook_V28916",
 			"component" : EBOOK_V28916
 		},
 		{
 			"path" : "/eBook_V28917",
 			"name" : "eBook_V28917",
 			"component" : EBOOK_V28917
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js